/**
 * ListIcon/index.js
 * desc: list icon
 * note: action icon via IconButton; defaults its tooltip + accessible name to the
 *       action label. Renders an accessible button when given an onClick handler.
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const ListIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="list icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.list.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg viewBox="0 0 20 15" xmlns="http://www.w3.org/2000/svg"><path d="M0 4.286h4.706V0H0v4.286zm4.706 5.357H0V5.357h4.706v4.286zm0 5.357H0v-4.286h4.706V15zM20 9.643H5.882V5.357H20v4.286zM5.882 15H20v-4.286H5.882V15zm0-10.714V0H20v4.286H5.882z"/></svg>
    </IconButton>
);


export default ListIcon;
